import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import Icon from '../../../components/AppIcon';

const TierDistributionChart = ({ tierData }) => {
  const getTierColor = (tier) => {
    switch (tier) {
      case 'Bronze':
        return '#CD7F32';
      case 'Silver':
        return '#C0C0C0';
      case 'Gold':
        return '#FFD700';
      case 'Platinum':
        return '#E5E4E2';
      default:
        return 'var(--color-primary)';
    }
  };

  const chartData = [
    { name: 'Bronze', value: tierData?.bronze || 0, color: getTierColor('Bronze') },
    { name: 'Silver', value: tierData?.silver || 0, color: getTierColor('Silver') },
    { name: 'Gold', value: tierData?.gold || 0, color: getTierColor('Gold') },
    { name: 'Platinum', value: tierData?.platinum || 0, color: getTierColor('Platinum') }
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg shadow-warm p-3">
          <p className="font-caption text-sm font-semibold mb-1">{payload?.[0]?.name} Tier</p>
          <p className="text-sm" style={{ color: payload?.[0]?.payload?.color }}>
            {payload?.[0]?.value} suppliers
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-xl shadow-warm p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="PieChart" size={24} color="var(--color-primary)" />
        <h3 className="text-lg md:text-xl font-heading font-bold text-foreground">Tier Distribution</h3>
      </div>
      <div className="w-full h-64 md:h-80">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, percent }) => `${name} ${(percent * 100)?.toFixed(0)}%`}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {chartData?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry?.color} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ fontSize: '14px' }}
              iconType="circle"
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default TierDistributionChart;